<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/178R5aJ/tc-custom/9781473866782.jpg?1729379484588" alt="This image is the cover for the book Allied Tanks of the Second World War, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Allied Tanks of the Second World War, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <p>Expert author Michael Green has compiled a full inventory of the tanks developed and deployed by the Allied armies during the six year war against Nazi Germany and her Axis partners.There were four categories of tank: Light, Medium, Heavy and Super Heavy. Combat experience proved Light tanks (such as the Stuart and T-26) to be ineffective.  Medium tanks (the US M4 series, named Sherman by the British, and Russian T-34) soon dominated with their fire power, protection and mobility.The later stages of the War required the Allies to answer the Axis Panther and Tiger tanks with up-gunned and up-armoured second generation M4s, T-34-85s and the Sherman Firefly.  Totally new heavy tanks such as the M-26, Pershing, Soviet KV-1 series and the British Centurion only saw action in the final months.Allied Tanks of the Second World War covers all these categories in detail as well as the few super heavy tanks such as the French Char 2C and the TOG.  For an informed and highly illustrated work this book has no comparable rival.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Green
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34377166